import { RouteObject, useSearchParams } from "react-router-dom";
import { TopBarPageContainer } from "@components/PageContainer";
import { ValidatedRoutes } from "@components/PermissionedRoutes";

export const PAYMENTS_MANAGER_ROUTES: RouteObject[] = [
  {
    index: true,
    async lazy() {
      const { PaymentsTable } = await import("@pages/payments_manager/PaymentsTable");
      return {
        Component() {
          const [searchParams] = useSearchParams();
          return (
            <TopBarPageContainer title={["Transactions", "ACH Manager", "Payments"]}>
              <PaymentsTable selectedId={searchParams.get("selectedId") ?? null} />
            </TopBarPageContainer>
          );
        },
      };
    },
  },
  {
    path: "ai_search",
    element: (
      <ValidatedRoutes
        validate={(userConfiguration) => {
          const { isFeatureEnabled, permissions } = userConfiguration;
          return (
            isFeatureEnabled("command_ai_search", "ach_payments_manager") &&
            permissions.includes("backoffice.use_ai_search")
          );
        }}
      />
    ),
    children: [
      {
        index: true,
        async lazy() {
          const { AiSearch } = await import("@pages/payments_manager/ai_search/AiSearch");
          return { element: <AiSearch /> };
        },
      },
      {
        path: ":threadId",
        async lazy() {
          const { PaymentsManagerAiThread } = await import(
            "@pages/payments_manager/ai_search/AiThread"
          );
          return { element: <PaymentsManagerAiThread /> };
        },
      },
    ],
  },
];
